// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsVerificationStatusesPage_wrapper__SWoX2"};